import { useRef, useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

const DropdownMenu = styled.div`
  min-width: 180px;
  width: max-content;
  max-width: 320px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 10000;
  position: fixed;
  scrollbar-width: thin;
  scrollbar-color: var(--Primary-Color-Shade-1) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--Primary-Color-Shade-1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--active-bg-color, #0a5a96);
  }
`;

const DropdownItem = styled.div`
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  letter-spacing: 0.06em;
  font-size: 12px;
  font-weight: 700;

  &:hover {
    background: var(--light-primary-color);
  }

  &:last-child {
    border-bottom: none;
  }
`;

const Dropdown = ({ items, onSelect, isOpen, onClose }) => {
  const anchorRef = useRef(null);
  const menuRef = useRef(null);
  const onCloseRef = useRef(onClose);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  onCloseRef.current = onClose;

  useLayoutEffect(() => {
    if (isOpen && anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setPos({ top: rect.top, left: rect.left });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current && !menuRef.current.contains(event.target) &&
        anchorRef.current && !anchorRef.current.contains(event.target)
      ) {
        onCloseRef.current();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (item) => {
    onSelect(item !== null && typeof item === "object" ? item.key : item);
    onCloseRef.current();
  };

  return (
    <div
      ref={anchorRef}
      style={{ position: "absolute", top: "100%", left: 0, width: 0, height: 0 }}
    >
      {isOpen && createPortal(
        <DropdownMenu ref={menuRef} style={{ top: pos.top, left: pos.left }}>
          {(items || []).map((item, index) => (
            <DropdownItem key={index} onClick={() => handleSelect(item)}>
              {item !== null && typeof item === "object" ? item.value : item}
            </DropdownItem>
          ))}
        </DropdownMenu>,
        document.body
      )}
    </div>
  );
};

export default Dropdown;
